import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PostForm from "../components/PostForm";
import Ticket from "../components/Ticket";

export default function Pos() {
  const [saleResult, setSaleResult] = useState(null);
  const navigate = useNavigate();

  const handleAfterPrint = () => {
    setSaleResult(null);

    // ¿Viene de cuenta separada? Regresar a la orden
    const pending = localStorage.getItem('pending_cuenta_separada');
    if (pending) {
      try {
        const { return_to_orden, items_facturados, total_items_orden } = JSON.parse(pending);
        localStorage.removeItem('pending_cuenta_separada');

        const todosFacturados = items_facturados.length >= total_items_orden;

        if (todosFacturados) {
          // Todos los items facturados, ir a mesas
          navigate('/mesas');
        } else {
          // Quedan items, regresar a la orden con estado
          navigate(`/ordenes/${return_to_orden}`, {
            state: {
              items_ya_facturados: items_facturados,
              abrir_separada: true,
            }
          });
        }
      } catch {
        localStorage.removeItem('pending_cuenta_separada');
      }
    }
  };

  return (
    <>
      <div className="container">
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Punto de Venta</h2>
          </div>
          <div className="card-body">
            <PostForm onSuccess={(data) => setSaleResult(data)} />
          </div>
        </div>
      </div>

      {saleResult && (
        <Ticket
          invoice={saleResult}
          onAfterPrint={handleAfterPrint}
        />
      )}
    </>
  );
}